/**
 * Feature flag for the Revenue column in the Email Campaigns list.
 *
 * Hidden while revenue attribution is not shipped — the backend does not
 * track per-campaign revenue today, and the product decisions around the
 * attribution model (time window, first-touch vs last-touch, what counts
 * as revenue) are pending. Showing an empty column would only confuse
 * merchants.
 *
 * Both the header cell (`EmailCampaignsList`) and the body cell
 * (`EmailCampaignsRow`) must gate off this same flag so the table's
 * column count stays consistent between header and rows. Flipping this
 * flag back to `true` re-enables the column everywhere at once — no
 * other change needed.
 */
export const SHOW_REVENUE_COLUMN = false;
